import React from "react";

/**
 * Right-side drawer. Visibility is caller-controlled.
 */
export function Drawer({ children, className = "" }) {
  return <div className={`ds-drawer ${className}`.trim()}>{children}</div>;
}
